import MiniTreeOrange from "../trees/MiniTreeOrange.jsx";
import MiniTreeYellow from "../trees/MiniTreeYellow.jsx";
import MiniTreeRed from "../trees/MiniTreeRed.jsx";
import MiniTreeGreen from "../trees/MiniTreeGreen.jsx";
import FloorBlock from "../race/block/FloorBlock.jsx";
import Work from "../work/Work.jsx";
import { BUTTON_IDS } from "../../stores/useGame";
import SurfaceButtonOpenSN from "../surfacebuttons/SurfaceButtonOpenSN.jsx";

const WorkZone = ({ position = [0, 0, 0] }) => {
  return (
    <group position={position}>
      <FloorBlock position={[-51.25, 0, 5]} scale={0.7} />
      <FloorBlock position={[-48.25, 0, 3]} scale={0.7} />
      <FloorBlock position={[-45.25, 0, 5]} scale={0.7} />
      <FloorBlock position={[-42.25, 0, 3]} scale={0.7} />

      <MiniTreeOrange position={[-18.75, 0, 11]} rotation={[0, 0, 0]} />
      <MiniTreeYellow position={[-18.75, 0, -1]} rotation={[0, 0, 0]} />
      <FloorBlock position={[-20.25, 0, 5]} scale={0.7} />
      <FloorBlock position={[-17.25, 0, 3]} scale={0.7} />

      <MiniTreeRed position={[6.25, 0, 11]} rotation={[0, 0, 0]} />
      <MiniTreeOrange position={[6.25, 0, -1]} rotation={[0, 0, 0]} />
      <FloorBlock position={[4.75, 0, 5]} scale={0.7} />
      <FloorBlock position={[7.75, 0, 3]} scale={0.7} />

      <MiniTreeGreen position={[26.25, 0, 11]} rotation={[0, 0, 0]} />
      <MiniTreeRed position={[26.25, 0, -1]} rotation={[0, 0, 0]} />
      <FloorBlock position={[24.75, 0, 3]} scale={0.7} />
      <FloorBlock position={[27.75, 0, 5]} scale={0.7} />

      <MiniTreeGreen position={[51.25, 0, 9]} rotation={[0, 0, 0]} />
      <MiniTreeRed position={[51.25, 0, 4]} rotation={[0, 0, 0]} />
      <MiniTreeYellow position={[51.25, 0, -1]} rotation={[0, 0, 0]} />
      <MiniTreeOrange position={[51.25, 0, -6]} rotation={[0, 0, 0]} />

      <SurfaceButtonOpenSN
        position={[-32, -0.98, 3]}
        buttonId={BUTTON_IDS.BOSTONGENE}
        width={3.5}
        height={1.5}
      />
      <SurfaceButtonOpenSN
        position={[-7, -0.98, 3]}
        buttonId={BUTTON_IDS.SBERTECH}
        width={3.5}
        height={1.5}
      />

      <Work position={[-51.25, 0, -10]} />
    </group>
  );
};

export default WorkZone;
